module.exports = __webpack_public_path__ + "static/assets/ea2f8b352c381356e3f056c2258a93d9.svg";